import React, { useState } from 'react';
import { X, Check } from 'lucide-react';
import { fabricOptions, embroideryOptions } from '../utils/catalog';


const FabricSelection = ({ isOpen, onClose, onSubmit }) => {
  const [selectedFabric, setSelectedFabric] = useState(null);
  const [selectedEmbroidery, setSelectedEmbroidery] = useState(null);
  const [step, setStep] = useState(1);

  const handleNext = () => {
    if (step === 1 && selectedFabric) {
      setStep(2);
    } else if (step === 2 && selectedEmbroidery) {
      // Submit selections
      if (onSubmit) {
        onSubmit({ fabric: selectedFabric, embroidery: selectedEmbroidery });
      }
      onClose();
    }
  };

  const handleBack = () => {
    if (step === 2) {
      setStep(1);
    }
  };

  const resetAndClose = () => {
    setSelectedFabric(null);
    setSelectedEmbroidery(null);
    setStep(1);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fabric-modal-overlay" onClick={resetAndClose} data-testid="fabric-selection-modal">
      <div className="fabric-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="fabric-modal-close" onClick={resetAndClose} data-testid="fabric-close-btn">
          <X size={24} />
        </button>

        <div className="fabric-modal-header">
          <h2 className="heading-2">
            {step === 1 ? 'Select Your Fabric' : 'Choose Your Embroidery'}
          </h2>
          <p className="body-regular fabric-modal-subtitle">
            {step === 1 
              ? 'Every masterpiece begins with the perfect canvas'
              : 'The art that brings your vision to life'
            }
          </p>
          <div className="fabric-step-indicator">
            <span className={`fabric-step ${step >= 1 ? 'active' : ''}`}>1. Fabric</span>
            <span className="fabric-step-divider">—</span>
            <span className={`fabric-step ${step >= 2 ? 'active' : ''}`}>2. Embroidery</span>
          </div>
        </div>

        <div className="fabric-options-grid">
          {step === 1 ? (
            fabricOptions.map((fabric) => (
              <div
                key={fabric.id}
                className={`fabric-option-card ${selectedFabric?.id === fabric.id ? 'selected' : ''}`}
                onClick={() => setSelectedFabric(fabric)}
                data-testid={`fabric-option-${fabric.id}`}
              >
                <div className="fabric-option-image-container">
                  <img src={fabric.image} alt={fabric.name} className="fabric-option-image" />
                  {selectedFabric?.id === fabric.id && (
                    <div className="fabric-selected-badge">
                      <Check size={16} />
                    </div>
                  )}
                </div>
                <div className="fabric-option-info">
                  <h3 className="heading-4">{fabric.name}</h3>
                  <p className="body-small fabric-option-origin">{fabric.origin}</p>
                  <p className="body-small fabric-option-desc">{fabric.description}</p>
                </div>
              </div>
            ))
          ) : (
            embroideryOptions.map((embroidery) => (
              <div
                key={embroidery.id}
                className={`fabric-option-card ${selectedEmbroidery?.id === embroidery.id ? 'selected' : ''}`}
                onClick={() => setSelectedEmbroidery(embroidery)}
                data-testid={`embroidery-option-${embroidery.id}`}
              >
                <div className="fabric-option-image-container">
                  <img src={embroidery.image} alt={embroidery.name} className="fabric-option-image" />
                  {selectedEmbroidery?.id === embroidery.id && (
                    <div className="fabric-selected-badge">
                      <Check size={16} />
                    </div>
                  )}
                </div>
                <div className="fabric-option-info">
                  <h3 className="heading-4">{embroidery.name}</h3>
                  <p className="body-small fabric-option-origin">{embroidery.hours}</p>
                  <p className="body-small fabric-option-desc">{embroidery.description}</p>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="fabric-modal-actions">
          {step === 2 && (
            <button className="btn-secondary" onClick={handleBack} data-testid="fabric-back-btn">
              Back
            </button>
          )}
          <button
            className="btn-primary"
            onClick={handleNext}
            disabled={step === 1 ? !selectedFabric : !selectedEmbroidery}
            data-testid="fabric-next-btn"
          >
            {step === 1 ? 'Next: Embroidery' : 'Complete Selection'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FabricSelection;
